import type { Vec3 } from './types.js'

export const v3 = (x = 0, y = 0, z = 0): Vec3 => ({ x, y, z })
export const clone = (a: Vec3): Vec3 => ({ x: a.x, y: a.y, z: a.z })
export const add = (a: Vec3, b: Vec3): Vec3 => ({ x: a.x + b.x, y: a.y + b.y, z: a.z + b.z })
export const sub = (a: Vec3, b: Vec3): Vec3 => ({ x: a.x - b.x, y: a.y - b.y, z: a.z - b.z })
export const scale = (a: Vec3, s: number): Vec3 => ({ x: a.x * s, y: a.y * s, z: a.z * s })
export const dotXZ = (a: Vec3, b: Vec3): number => a.x * b.x + a.z * b.z
export const lenXZ = (a: Vec3): number => Math.hypot(a.x, a.z)
export const distXZ = (a: Vec3, b: Vec3): number => Math.hypot(a.x - b.x, a.z - b.z)
export function normXZ(a: Vec3): Vec3 {
  const l = lenXZ(a)
  return l > 1e-9 ? { x: a.x / l, y: 0, z: a.z / l } : { x: 0, y: 0, z: 0 }
}
export const clamp = (v: number, lo: number, hi: number): number => (v < lo ? lo : v > hi ? hi : v)
